import { NgModule } from '@angular/core';
import { StaffProfileComponent, StaffSwitcherComponent, ScreenLockerSheetComponent } from './components';
import { ShopboxCommonModule } from '@shared/common/common.module';

@NgModule({
    imports: [
        ShopboxCommonModule,
        StaffProfileComponent, StaffSwitcherComponent, ScreenLockerSheetComponent
    ],
    exports: [
        StaffProfileComponent
    ]
})
export class StaffProfileModule { }
